import React from "react";
import { Button as NovusButton } from "@arcadis-intelligence/novus-design-system";
import { btnStyles } from "components/Novus/variants";

interface ButtonProps
    extends React.ComponentProps<typeof NovusButton>,
        React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?:
        | "primary"
        | "secondary"
        | "tertiary"
        | "default"
        | "danger"
        | "dangerTertiary"
        | "warning"
        | "defaultSecondary"
        | "defaultTertiary"
        | string;
}

export const Button: React.FC<ButtonProps> = (props) => {
    const getButtonStyles = (variant: ButtonProps["variant"]) => {
        switch (variant) {
            case "default":
                return btnStyles.default;
            case "primary":
                return btnStyles.primary;
            case "secondary":
                return btnStyles.secondary;
            case "tertiary":
                return btnStyles.tertiary;
            case "danger":
                return btnStyles.danger;
            case "dangerTertiary":
                return btnStyles.dangerTertiary;
            case "defaultSecondary":
                return btnStyles.defaultSecondary;
            case "warning":
                return btnStyles.warning;
            case "defaultTertiary":
                return btnStyles.defaultTertiary;
            default:
                return btnStyles.default;
        }
    };
    return <NovusButton {...props} {...getButtonStyles(props.variant || "primary")} />;
};
